import {useEffect, useRef, useState} from 'react';
import {useSearchParams} from 'react-router-dom';

import usePlatformStore from '../store/platformStore/platformStore';
import {checkCurrentYearOrBelow} from '../utils/commonFunctions';

const resolveYear = (facilitySelectedYear: string): string => {
  return checkCurrentYearOrBelow(facilitySelectedYear || null);
};

export const useGlobalYear = (): {
  selectedYear: string;
  setSelectedYear: React.Dispatch<React.SetStateAction<string>>;
} => {
  const [, setSearchParams] = useSearchParams();
  const facilitySelectedYear = usePlatformStore(
    (state) => state.facilitySelectedYear
  );
  const [selectedYear, setSelectedYear] = useState(() =>
    resolveYear(facilitySelectedYear)
  );
  const skipFacilitySync = useRef(true);

  useEffect(() => {
    if (skipFacilitySync.current) {
      skipFacilitySync.current = false;

      return;
    }
    setSelectedYear(resolveYear(facilitySelectedYear));
  }, [facilitySelectedYear]);

  useEffect(() => {
    if (!selectedYear) {
      return;
    }
    setSearchParams(
      (currentParams) => {
        if (currentParams.get('selectedYear') === selectedYear) {
          return currentParams;
        }
        const nextParams = new URLSearchParams(currentParams);
        nextParams.set('selectedYear', selectedYear);

        return nextParams;
      },
      {replace: true}
    );
  }, [selectedYear, setSearchParams]);

  return {selectedYear, setSelectedYear};
};
